import {CONTRACTORS_REQUEST, CONTRACTORS_SUCCESS, CONTRACTORS_FAILURE} from '../actions';
import {STORE_CONTRACTOR_REQUEST, STORE_CONTRACTOR_SUCCESS, STORE_CONTRACTOR_FAILURE} from '../actions';
import {UPDATE_LANDLORD_CONTRACTOR_REQUEST, UPDATE_LANDLORD_CONTRACTOR_SUCCESS, UPDATE_LANDLORD_CONTRACTOR_FAILURE} from '../actions';
import contractorReducer from './landlord-contractor';

export const CONTRACTORS_INITIAL_STATE = {
    isFetching: false,
    data: [],
    links: {},
    meta: {},
    error: null
};

const updateContractor = (state, action) => {
    let {data} = state;
    const {id} = action;
    const contractor = data.find(b => b.id === id);
    const reduced = contractorReducer(contractor, action);
    data.splice(data.indexOf(contractor), 1, reduced);
    data = [...state.data];

    return {...state, data};
};

const contractorsReducers = {
    [CONTRACTORS_REQUEST]: (state) => {
        return {...state, isFetching: true, error: null};
    },
    [CONTRACTORS_SUCCESS]: (state, {res}) => {
        return {...state, ...res, isFetching: false, error: null};
    },
    [CONTRACTORS_FAILURE]: (state, {error}) => {
        return {...state, isFetching: false, error};
    },
    [STORE_CONTRACTOR_REQUEST]: (state, action) => {
        const contractor = contractorReducer(undefined, action);
        const data = [...state.data.filter(b => !b.draft), contractor];

        return {...state, data};
    },
    [STORE_CONTRACTOR_SUCCESS]: (state, action) => {
        let {data} = state;
        const contractor = data.find(b => b.draft);
        data.splice(data.indexOf(contractor), 1);
        const reduced = contractorReducer(contractor, action);
        data = [...data, reduced];

        return {...state, data};
    },
    [STORE_CONTRACTOR_FAILURE]: (state, action) => {
        let {data} = state;
        const contractor = data.find(b => b.draft);
        data.splice(data.indexOf(contractor), 1);
        const reduced = contractorReducer(contractor, action);
        data = [...state.data, reduced];

        return {...state, data};
    },
    [UPDATE_LANDLORD_CONTRACTOR_REQUEST]: updateContractor,
    [UPDATE_LANDLORD_CONTRACTOR_SUCCESS]: updateContractor,
    [UPDATE_LANDLORD_CONTRACTOR_FAILURE]: updateContractor
};

export default function contractors(state = CONTRACTORS_INITIAL_STATE, action) {
    let reducer = contractorsReducers[action.type] || (state => state);
    return reducer(state, action);
}


// WEBPACK FOOTER //
// ./resources/assets/js/reducers/contractors.js